// TODO fix return value of command REST API call
export function isCommandTimeout(response: any) {
  return response.code === 'CREATED_COMMAND_TIMEOUT'
}
